export default {
  NORMAL: 'NORMAL',
  SOON: 'SOON',
};
